// extracted by mini-css-extract-plugin
module.exports = {"LogoMarcaWrapper":"Peca_LogoMarcaWrapper__KFany","LogoMarca":"Peca_LogoMarca__-PYY7"};